'use client';

import React, { createContext, useEffect, useState } from 'react';

export const ScrollContext = createContext();

export const ScrollProvider = ({ children }) => {
  const [scrollLength, setScrollLength] = useState(0);

  useEffect(() => {
    const updateScrollLength = () => {
      const scrollY = window.scrollY; // Current vertical scroll position
      const scrollHeight = document.documentElement.scrollHeight; // Total scrollable height
      const clientHeight = window.innerHeight; // Viewport height
      const scrollableHeight = scrollHeight - clientHeight; // Total scrollable distance

      const scrollProgress = Math.min(1, scrollY / scrollableHeight); // Normalize between 0 and 1
      setScrollLength(scrollProgress);
    };

    window.addEventListener('scroll', updateScrollLength);

    // Initial calculation
    updateScrollLength();

    return () => {
      window.removeEventListener('scroll', updateScrollLength);
    };
  }, []);

  return (
    <ScrollContext.Provider value={scrollLength}>
      {children}
    </ScrollContext.Provider>
  );
};
